module.exports = __webpack_public_path__ + "static/media/siuDemo.b2d42a92.mp4";